import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _includes from 'lodash/includes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ChatBot from '../../contactUs/components/ChatBot';
import ArticlePanel from './ArticlePanel';
import { loadModalContainer } from '../../contactUs/actions/action-login-modal';
import { chatBotClickedAction } from '../../contactUs/actions/action-chat-bot';
import Page from '../../lib/page';

const isLoggedIn = Page.isLoggedIn();
const isArticleChatBotEligible = Page.getIsArticleChatBotEligible(); // pxp exp
const articlesForChatBot = Page.getArticlesForChatBot(); // remote config check for articles to enable chatbot
const articleFaqId = Page.getArticleId();
const isArticlePage = Page.isArticlePage();

class ArticleChatBotContainer extends Component {
  constructor(props) {
    super(props);
    this.chatBotClicked = this.chatBotClicked.bind(this);
  }

  chatBotClicked() {
        // Let's open up the login modal.
    if (!isLoggedIn) {
      this.props.chatBotClickedAction();
      return this.props.loadModalContainer('chatBot');
    }
    return null;
  }

  render() {
    const display = isArticleChatBotEligible && isArticlePage && _includes(articlesForChatBot, articleFaqId);
    if (!display) {
      return (<ArticlePanel />);
    }
    return (
      <div>
        <ArticlePanel />
        <ChatBot link="smarthelp-chat-bot-article" id="chatBotArticle" hpid={articleFaqId} display={display} chatBotClicked={this.chatBotClicked} />
      </div>);
  }
}

ArticleChatBotContainer.propTypes = {
  loadModalContainer: PropTypes.func.isRequired,
  chatBotClickedAction: PropTypes.func,
};

ArticleChatBotContainer.defaultProps = {
  chatBotClickedAction: () => {},
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ loadModalContainer, chatBotClickedAction }, dispatch);
}

export default connect(null, mapDispatchToProps)(ArticleChatBotContainer);
